import LocalStorageService from '../../services/storage/local-storage-service';

export const StateWatcherPlugin = (store) => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'addFavorite':
      case 'removeFavorite':
      case 'updateFavoriteMatches':
        LocalStorageService.set('favorites', state.favoritesModule.favorites);
        break;
      case 'addFavoriteSport':
      case 'removeFavoriteSport':
        LocalStorageService.set('favoriteSports', state.favoritesModule.sports);
        break;
      case 'addFavoriteTournament':
      case 'removeFavoriteTournament':
        LocalStorageService.set('favoriteTournaments', state.favoritesModule.tournaments);
        break;
      case 'addFavoriteCategory':
      case 'removeFavoriteCategory':
        LocalStorageService.set('favoriteCategories', state.favoritesModule.categories);
        break;
      case 'addFilter':
      case 'remFilter':
        LocalStorageService.set('FF', state.FixtureFilterModule.savedFilters);
        break;
      default:
        break;
    }
  });
};
